import { render, staticRenderFns } from "./renx.vue?vue&type=template&id=15f04076&scoped=true&"
import script from "./renx.vue?vue&type=script&lang=js&"
export * from "./renx.vue?vue&type=script&lang=js&"
import style0 from "./renx.vue?vue&type=style&index=0&id=15f04076&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f04076",
  null
  
)

export default component.exports